import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useDispatchTrackErrorEvent } from '@grandvisionhq/svc-tealium/events';
import { isNil } from '@grandvisionhq/utils';
import '../operations/fragments/cart-details.js';
import '../operations/fragments/cart-validation-errors.js';
import '../operations/fragments/recover-inactive-cart-failure.js';
import '../operations/fragments/recover-inactive-cart-result.js';
import '../operations/mutations/add-cart-line-items.js';
import '../operations/mutations/add-cart-voucher-codes.js';
import '../operations/mutations/create-cart.js';
import '../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../operations/mutations/create-cart-from-order.js';
import { DUPLICATE_CART_LINE_ITEMS } from '../operations/mutations/duplicate-cart-line-items.js';
import '../operations/mutations/remove-cart-voucher-codes.js';
import '../operations/mutations/remove-cart-line-items.js';
import '../operations/mutations/update-cart-line-items.js';
import '../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../operations/mutations/recover-inactive-cart.js';
import '../operations/queries/get-cart.js';
import '../operations/queries/get-total-line-items.js';
import '../operations/queries/get-cart-estimated-delivery.js';
import '../utils/cart-count-var.js';
import '../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import { getValidationErrorCodes } from '../utils/get-validation-error-codes.js';
import '../utils/get-unrecoverable-validation-errors.js';
import '../models/add-to-cart/add-to-cart.js';
import '../models/cart/cart.js';
import '../models/subscription/subscription-details.js';
import '../models/checkoutState/checkoutState.js';
import '../models/line-item/prescription-glasses.js';
import '../utils/get-failure-error-codes.js';

const useDuplicateCartLineItems = (lineItem, onSuccess)=>{
    const [{ cartId  }, { setCartCount  }] = useCartStorage();
    const handleValidationErrors = (validationErrors)=>{
        validationErrors.forEach((validationError)=>toast.failed(`cart.${validationError}`)
        );
    };
    const dispatchTrackErrorEvent = useDispatchTrackErrorEvent();
    const handleTrackErrorTealium = (errorDetails, errorMessage)=>dispatchTrackErrorEvent(()=>Promise.resolve(swcHelpers.objectSpread({
                Error_Source: 'Server',
                Error_Code: 'Duplicate cart error',
                Error_Details: errorDetails
            }, errorMessage ? {
                Error_Message: errorMessage
            } : {}))
        )
    ;
    const [duplicateCartLineItems, duplicateCartLineItemsMutation] = useMutation(DUPLICATE_CART_LINE_ITEMS, {
        onCompleted: (response)=>{
            if ('duplicateCartLineItems' in response) {
                const { success , cart , validationErrors  } = response.duplicateCartLineItems;
                success && cart && setCartCount(cart.numberOfItems);
                if (!success && validationErrors) {
                    const validationErrorCodes = getValidationErrorCodes(validationErrors);
                    handleValidationErrors(validationErrorCodes);
                }
            }
            onSuccess && onSuccess();
        }
    });
    const duplicateToCart = React.useCallback(()=>{
        if (isNil(cartId)) {
            console.error('No cart ID available');
            handleTrackErrorTealium('No cart ID available');
            return;
        }
        duplicateCartLineItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItem.id
                        }, 
                    ]
                }
            }
        });
    }, [
        cartId,
        duplicateCartLineItems,
        lineItem.id,
        handleTrackErrorTealium
    ]);
    const { called , loading , error  } = duplicateCartLineItemsMutation;
    return [
        duplicateToCart,
        {
            called,
            loading,
            error
        }
    ];
};

export { useDuplicateCartLineItems };
//# sourceMappingURL=use-duplicate-cart-line-items.js.map
